// extracted by mini-css-extract-plugin
export default {"pageTitle":"partner_pageTitle__9gvUN","partner":"partner_partner__vYn8V"};